import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { ScreenCaptureDialog } from "./ScreenCaptureDialog";
import { Monitor } from "lucide-react";

export interface ScreenCaptureButtonProps {
  /** Called with (dataUrl, meta). Parent should add to fileAttached and optionally switch to vision model. */
  onCapture: (dataUrl: string, meta: { source: "screen-capture"; url?: string; resolution?: string; userAgent?: string }) => void;
  /** Called when user chose "Capture as text" and OCR finished. Parent should set input to this text. */
  onCaptureText?: (text: string) => void;
  /** Optional: when image is attached, parent can prefill input with a suggestion. */
  onSuggestPrompt?: (prompt: string) => void;
  /** Countdown seconds (0 = no countdown). Default 5. */
  countdownSeconds?: number;
  disabled?: boolean;
  className?: string;
}

export function ScreenCaptureButton({
  onCapture,
  onCaptureText,
  onSuggestPrompt,
  countdownSeconds = 2,
  disabled,
  className,
}: ScreenCaptureButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className={className}
            disabled={disabled}
            onClick={() => setOpen(true)}
            aria-label="Capture screen"
          >
            <Monitor className="h-4 w-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="top">
          Capture screen for the AI to read (bugs, UI, errors)
        </TooltipContent>
      </Tooltip>
      <ScreenCaptureDialog
        open={open}
        onOpenChange={setOpen}
        onCapture={onCapture}
        onCaptureText={onCaptureText}
        onSuggestPrompt={onSuggestPrompt}
        countdownSeconds={countdownSeconds}
      />
    </>
  );
}
